import {
  GET_EMPLOYEES_LIST,
  convertParams,
  convertResult,
} from 'app/common/api/requests/reports/employees_list/get'

import { EmployeesListRequestParams } from 'app/common/types/employees/employees-list'

import { api } from 'app/api'

export const getEmployees = async (params: EmployeesListRequestParams, signal?: AbortSignal) => {
  const res = await api.request(GET_EMPLOYEES_LIST, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные сотрудников',
    params,
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res
}
